<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { AppText } from '@shared/ui/typography'

import { useKanbanLogComment } from '../../model/log/use-kanban-log-comment.hook'
import KanbanLogItemInfo from './KanbanLogItemInfo.vue'

defineOptions({
  name: 'KanbanLogComment',
})

const props = defineProps<{
  actor: KanbanLogActor | null
  action: string
  value: string | null
}>()

const {
  refLabel,
  refComment,
} = useKanbanLogComment({
  action: props.action,
  value: props.value,
})
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      :label="refLabel"
    />
    <AppText
      v-if="refComment"
      name="body2"
      color="slate-900"
      block
    >
      {{ refComment }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />